import { Card } from "../../molecules/mui/main";
import { CustomcardProps } from "./card.types";
import { forwardRef } from "react";
export default forwardRef(function CustomCard(
  {
    children,
    style,
    cardActive,
    elevation = 0,
    boxShadow,
    id,
    onMouseLeave,
  }: CustomcardProps,
  ref:
    | ((instance: HTMLDivElement | null) => void)
    | React.RefObject<HTMLDivElement>
    | null
    | undefined,
) {
  return (
    <Card
      sx={{
        ...style,
        boxShadow: cardActive ? boxShadow : "",
      }}
      elevation={elevation}
      onMouseLeave={onMouseLeave}
      id={id}
      ref={ref}
    >
      {children}
    </Card>
  );
});
